export const SecugenErrors = {
    ERROR_NONE: "Function Success",
    ERROR_CREATION_FAILED: "Failed to create SGFPM instance",
    ERROR_FUNCTION_FAILED: "Function failed to call for unknown reason",
    ERROR_INVALID_PARAM: "Invalid parameter",
    ERROR_NOT_USED: "Function is not used or not supported",
    ERROR_DLLLOAD_FAILED: "Failed to load sgfplib.dll. Make sure that sgfplib.dll is located at node's path",
    ERROR_DLLLOAD_FAILED_DRV: "Cannot load device driver",
    ERROR_DLLLOAD_FAILED_ALGO: "Cannot load matching module",
    ERROR_NO_LONGER_SUPPORTED: "Function is no longer supported",
    ERROR_DLLLOAD_FAILED_WSQ: "Sgwsqlib.dll not loaded",
    ERROR_SYSLOAD_FAILED: "Failed to load driver sys file",
    ERROR_INITIALIZE_FAILED: "Failed to initialize device",
    ERROR_LINE_DROPPED: "Image data loss occurred during capture",
    ERROR_TIME_OUT: "Timeout occurred during capture",
    ERROR_DEVICE_NOT_FOUND: "Device not found",
    ERROR_WRONG_IMAGE: "Wrong image - not recognized as a fingerprint image",
    ERROR_LACK_OF_BANDWIDTH: "USB Bandwidth is not sufficient for image transfer",
    ERROR_DEV_ALREADY_OPEN: "Device is already in use",
    ERROR_GETSN_FAILED: "Failed to get serial number of the device",
    ERROR_UNSUPPORTED_DEV: "Cannot determine device type",
    ERROR_FAKE_FINGER: "Fake finger detected",
    ERROR_FAKE_INITIALIZED: "Initialization of fake module failed",
    ERROR_FEAT_NUMBER: "Not enough minutiae features",
    ERROR_INVALID_TEMPLATE_TYPE: "Template type is invalid",
    ERROR_INVALID_TEMPLATE1: "1st template is invalid",
    ERROR_INVALID_TEMPLATE2: "2nd template is invalid",
    ERROR_EXTRACT_FAIL: "Failed to extract template",
    ERROR_MATCH_FAIL: "Cannot find matched template",
    ERROR_LICENSE_LOAD: "Failed to load license",
    ERROR_LICENSE_KEY: "Invalid license key",
    ERROR_LICENSE_EXPIRED: "License expired",
    ERROR_NO_IMAGE: "Invalid image",
    // Custom errors
    AUTO_ON_ACTIVE: "Auto-On is currently active. Please turn off before executing this function.",
    AUTO_ON_NOT_ACTIVE: "Auto-On is not active. Please turn on before executing this function.",
    DEVICE_NOT_OPENED: "Device is not opened",
    CAPTURE_LOW_QUALITY: "Capture image quality is too low",
    // Binding-specific errors
    CAPTURE_TIMEOUT: "Capture timeout",
    CAPTURE_CANCELLED: "Capture was cancelled",
    MISC_ERROR: "Miscellaneous error",
    FAILURE_TO_INIT: "Module not initialized",
};
export const UnsupportedPlatformPayload = {
    ok: false,
    code: "FAILURE_TO_INIT",
    message: "Module not initialized",
};
export const AutoOnEvent = {
    FingerOn: "fingerOn",
    FingerOff: "fingerOff",
    Capture: "capture",
    SystemError: "error",
};
